import React from 'react';
import { Divider } from 'components/elements/divider/Divider';

import { CTA } from 'components/cta/CTA';

export const Component = () => {
  return (
    <>
      <Divider>Default</Divider>

      <CTA
        isSlice
        tagline="Worldwide"
        title="Worldwide Offices"
        text={
          <p>
            Alvogen has commercial operations in 35 countries, with regional hubs, manufacturing and
            R&D capabilities in the U.S., South Korea and Romania.
          </p>
        }
        label="Discover offices"
      />

      <Divider>With 3D globe</Divider>

      <CTA
        isSlice
        tagline="Worldwide"
        title="Worldwide Offices"
        text={
          <p>
            Alvogen has commercial operations in 35 countries, with regional hubs, manufacturing and
            R&D capabilities in the U.S., South Korea and Romania.
          </p>
        }
        label="Discover offices"
        globe
      />
    </>
  );
};
